import {
  FormControl,
  FormLabel,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
type OpenSourceFormProps = {
  handleOpenSourceSelection: (e: any) => void;
  openSource: string;
};
const OpenSourceForm = ({
  handleOpenSourceSelection,
  openSource,
}: OpenSourceFormProps) => {
  return (
    <FormControl>
      <FormLabel id="open-source-radio-buttons-label">
        Will you open source your code after the challenge?
      </FormLabel>
      <FormHelperText id="open-source-helper-text">
        You must answer Yes to be eligible for awards. You can change your
        choice later.
      </FormHelperText>
      <RadioGroup
        aria-labelledby="open-source-radio-buttons-label"
        name="radio-buttons-group"
        value={openSource}
        onChange={handleOpenSourceSelection}
      >
        <FormControlLabel
          value="Yes, training code, evaluation code, and trained models."
          control={<Radio />}
          label="Yes, training code, evaluation code, and trained models."
        />
        <FormControlLabel
          value="No, but I can provide evaluation code and trained models."
          control={<Radio />}
          label="No, but I can provide evaluation code and trained models."
        />
        <FormControlLabel
          value="No, none of our work will be open source."
          control={<Radio />}
          label="No, none of our work will be open source."
        />
      </RadioGroup>
    </FormControl>
  );
};
export default OpenSourceForm;
